<template>
<CCard>
  <CCardHeader>
    <h2>部署登録</h2>
  </CCardHeader>
  <CCardBody>
    <p><span class="preika-required-note"><span class="preika-required-note__mark" aria-hidden="true">*</span><span>が付いている項目は必須入力項目です</span></span></p>

    <CRow>
      <CCol sm="4">
        <label>部署名<span class="asterisk">*</span></label>
        <CInput v-model="name" maxlength="60" />
      </CCol>
    </CRow>

    <CRow>
      <CCol sm="4">
        <label>部署コード</label>
        <CInput v-model="code" maxlength="30" />
      </CCol>
    </CRow>

    <CRow>
      <CCol sm="4">
        <label>親部署</label>
        <select class="custom-select" v-model="parent_id">
          <option :value="''">未設定</option>
          <option v-for="option in parentOptions" :key="option.id" :value="option.id">
            {{ option.name }}
          </option>
        </select>
      </CCol>
    </CRow>

    <CRow>
      <CCol sm="4">
        <label>部署長</label>
        <select class="custom-select" v-model="head_user_id">
          <option :value="''">未設定</option>
          <option v-for="option in headUserOptions" :key="option.id" :value="option.id">
            {{ option.name }}
          </option>
        </select>
      </CCol>
    </CRow>

    <CRow>
      <CCol sm="2">
        <label>並び優先度</label>
        <CInput type="number" v-model="order_level" />
      </CCol>
    </CRow>

    <CRow>
      <CCol sm="6">
        <label>備考</label>
        <CTextarea v-model="remarks" rows="3" maxlength="100" />
      </CCol>
    </CRow>

    <br>

    <CRow class="mt-3 align-items-center">
      <CCol class="text-start">
        <button class="btn btn-secondary btn-sm" @click="valueCheck">戻る</button>
      </CCol>
      <CCol class="text-center">
        <button v-on:click="openModal" class="btn btn-info" :disabled="!name">確認</button>
        <RegisterModal
          :name="name"
          :code="code"
          :parent_name="selectedParentName"
          :head_user_name="selectedHeadUserName"
          :order_level="orderLevelNumber"
          :remarks="remarks"
          :loading="loading"
          :error="saveError"
          v-show="showModal"
          @register="register"
          @close="closeModal"
        />
      </CCol>
      <CCol></CCol>
    </CRow>
  </CCardBody>
</CCard>
</template>

<script>
import ConstList from './../ConstList'
import { requestFailureMessage } from '@/utils/requestFailure'
import RegisterModal from './RegisterModal'
import { japaneseOr } from '@/utils/japaneseText'
import axios from 'axios'

export default {
  name: 'DepartmentRegisterInput',
  components: { RegisterModal },
  data() {
    return {
      showModal: false,
      name: '',
      code: '',
      parent_id: '',
      head_user_id: '',
      order_level: 0,
      remarks: '',
      parentOptions: [],
      headUserOptions: [],
      // 登録を断られた理由。確認の小窓を閉じずに、小窓の中に出す。
      saveError: '',
      list: '',
      loading: false
    }
  },
  created() {
    this.list = ConstList.DEPARTMENT_ROUTE_LIST
  },
  mounted: function () {
    this.fetchParentOptions()
    this.fetchHeadUserOptions()
  },
  computed: {
    orderLevelNumber() {
      const n = Number(this.order_level)
      return Number.isFinite(n) ? n : 0
    },
    selectedParentName() {
      const row = this.parentOptions.find(({ id }) => String(id) === String(this.parent_id))
      return row ? row.name : ''
    },
    selectedHeadUserName() {
      const row = this.headUserOptions.find(({ id }) => String(id) === String(this.head_user_id))
      return row ? row.name : ''
    }
  },
  methods: {
    fetchParentOptions: function () {
      axios
        .get(process.env.VUE_APP_API_ORIGIN + '/departments/options/parents')
        .then((response) => {
          this.parentOptions = response.data
        })
        .catch((error) => {
          axios
            .post(`${process.env.VUE_APP_API_ORIGIN}/error/frontError`, { error: error.message || String(error) }, { headers: { 'Content-Type': 'application/json' } })
            .then(() => alert(requestFailureMessage(error)))
            .catch(() => alert(requestFailureMessage(error, ConstList.SYSTEM_COMMUNICATION_ERROR)))
        })
    },
    fetchHeadUserOptions: function () {
      axios
        .get(process.env.VUE_APP_API_ORIGIN + '/departments/options/head-users')
        .then((response) => {
          this.headUserOptions = response.data
        })
        .catch((error) => {
          axios
            .post(`${process.env.VUE_APP_API_ORIGIN}/error/frontError`, { error: error.message || String(error) }, { headers: { 'Content-Type': 'application/json' } })
            .then(() => alert(requestFailureMessage(error)))
            .catch(() => alert(requestFailureMessage(error, ConstList.SYSTEM_COMMUNICATION_ERROR)))
        })
    },
    valueCheck: function () {
      if (this.name || this.code || this.parent_id || this.head_user_id || this.remarks || Number(this.order_level) !== 0) {
        if (confirm(ConstList.TRANSITION)) {
          this.$router.push({ name: this.list })
        }
      } else {
        this.$router.push({ name: this.list })
      }
    },
    openModal: function () {
      this.saveError = ''
      this.showModal = true
    },
    closeModal: function () {
      // 送っているあいだは閉じない（2026-09-26 監査）。閉じると、あとから届いた理由を出す場所がなくなる。
      if (this.loading) return
      this.showModal = false
      this.saveError = ''
    },
    register: function () {
      this.loading = true
      this.saveError = ''
      const params = new URLSearchParams()
      params.append('name', this.name)
      params.append('code', this.code || '')
      params.append('parent_id', this.parent_id === '' ? '' : Number(this.parent_id))
      params.append('head_user_id', this.head_user_id === '' ? '' : Number(this.head_user_id))
      params.append('order_level', this.orderLevelNumber)
      params.append('remarks', this.remarks || '')
      params.append('deleted_flg', ConstList.REMAIN)

      axios
        .post(process.env.VUE_APP_API_ORIGIN + '/departments/register', params)
        .then((response) => {
          if (response.data === ConstList.SUCCESS) {
            alert(ConstList.REGISTER_MESSAGE)
            this.$router.push({ name: this.list })
          } else {
            // サーバは断ると英字の「NG」だけを返す。そのまま出さない。
            this.saveError = japaneseOr(response.data, '登録できませんでした。入力内容をご確認のうえ、再度お試しください。')
          }
        })
        .catch((error) => {
          axios
            .post(`${process.env.VUE_APP_API_ORIGIN}/error/frontError`, { error: error.message || String(error) }, { headers: { 'Content-Type': 'application/json' } })
            .then(() => alert(requestFailureMessage(error)))
            .catch(() => alert(requestFailureMessage(error, ConstList.SYSTEM_COMMUNICATION_ERROR)))
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>

<style scoped>
.asterisk { color: red; }
button:disabled { cursor: not-allowed; }
</style>
